module.exports = __webpack_public_path__ + "img/banner.998f696f.jpg";